<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <div>
        <v-btn @click="$router.push({ name: 'Payments' })" text class="pl-0">
          <v-icon class="mr-1" size="15px"> mdi-arrow-left </v-icon>
          <span class="text-return mon-regular" style="font-family: 'montserrat-medium';">{{ "Regresar" }}</span>
        </v-btn>
      </div>
      <div v-if="!isLoading">
        <v-row justify="start" align="start" class="ma-0 mt-5 mb-4">
          <v-col cols="12" class="pa-0">
            <div class="headline-medium text-primary">Detalle de egreso</div>
          </v-col>
        </v-row>
        <v-card-text class="pb-5 px-10" >
          <v-row class="mb-4" style="display: flex; align-items: center;">
            <v-col cols="12" lg="4">
              <div style="color: black; font-size: 20px;">
                ID: <span style="color: black; font-size: 22px; font-weight: bold;"> {{ item.iTrackingId }}</span>
              </div>
            </v-col>
            <v-col cols="12" lg="4"  style="text-align: center;">
              <v-chip
                v-if="item.transaction[0].transaction.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'"
                class="ma-2"
                color="red"
                outlined
              >
                {{ "Forward" }}
              </v-chip>
              <v-chip
                v-else-if="item.transaction[0].transaction.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'"
                class="ma-2"
                color="blue"
                outlined
              >
                {{ "Forex" }}
              </v-chip>
              <v-chip
                v-else
                class="ma-2"
                color="orange"
                outlined
              >
                {{ "Pay Now" }}
              </v-chip>
            </v-col>
            <v-col cols="12" lg="4" style="text-align: end;">
              <v-btn small color="#0075B8" @click="downloadReceipt()" class="white--text">
                <h4 style="font-family: 'montserrat-bold';">Descargar</h4>
                <v-icon right>mdi-download</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="mb-4" style="display: flex; align-items: center;">
            <v-col cols="12" lg="4">
              <div style="color: black; font-size: 20px;">
                Exchange rate: <span style="color: black; font-size: 22px; font-weight: bold;"> {{ "$ " + formatMoney(item.dRate) + " MXN" }}</span>
              </div>
            </v-col>
            <v-col cols="12" lg="4"  style="text-align: center;">
              <div style="color: black; font-size: 20px;">
                Amount (USD): <span style="color: black; font-size: 22px; font-weight: bold;"> {{ "$ " + formatMoney(item.dAmount) + " USD" }}</span>
              </div>
            </v-col>
            <v-col cols="12" lg="4" style="text-align: end;">
              <div style="color: black; font-size: 20px;">
                Amount (MXN): <span style="color: black; font-size: 22px; font-weight: bold;"> {{ "$ " + formatMoney(item?.dDescAmount) + " MXN" }}</span>
              </div>
            </v-col>
          </v-row>
          <v-row class="mb-4" style="display: flex; align-items: center;">
            <v-col cols="12" lg="6">
              <div style="color: black; font-size: 20px;">
                Destinatario: <span style="color: black; font-size: 22px; font-weight: bold;"> {{ item.payment_recipient.sName }}</span>
              </div>
            </v-col>
            <v-col cols="12" lg="6" style="text-align: end;">
              <div style="color: black; font-size: 20px;">
                Fecha de pago: <span style="color: black; font-size: 22px; font-weight: bold;"> {{ formatDate(item.dPaymentDate) }}</span>
              </div>
            </v-col>
          </v-row>
          <v-row class="mb-8" style="display: flex; align-items: center;">
            <v-col cols="12" lg="6">
              <div style="color: black; font-size: 20px;">
                Nombre de banco: <span style="color: black; font-size: 22px; font-weight: bold;"> {{ item.payment_recipient.sBankName }}</span>
              </div>
            </v-col>
            <v-col cols="12" lg="6" style="text-align: end;">
              <div style="color: black; font-size: 20px;">
                Número de clabe: <span style="color: black; font-size: 22px; font-weight: bold;"> {{ item.payment_recipient.sAccountNumber }}</span>
              </div>
            </v-col>
          </v-row>
          <div class="mb-8 mt-4">
            <div class="mb-4" style="color: black; font-size: 22px; font-weight: bold;">Porcentaje de pago aplicado</div>
            <v-progress-linear
              height="45"
              :value="((dTotalAmount / dDescAmount) * 100)"
            >
              <strong style="color: white;">{{ formatMoney(((dTotalAmount / dDescAmount) * 100)) }}%</strong>
            </v-progress-linear>
          </div>
          <v-card elevation="5" class="pa-4">
            <div class="mb-6 px-1" style="display: flex; justify-content: space-around; color: black; font-size: 22px; font-weight: bold; align-items: center;"> 
              <div>Facturas asignadas</div>
              <v-spacer></v-spacer>
              <!-- <v-btn
                style="
                  text-align: center;
                  color: #0075B8;
                  font-size: 15px;
                  background-color: transparent;
                  font-family: montserrat-bold;
                  font-weight: 600;
                  line-height: 24px;
                  text-transform: capitalize;
                  word-wrap: break-word;
                  border-radius: 5px;
                  border: 1px solid #0075B8;
                  padding: 8px 16px;
                "
                elevation="0"
                @click="updateInvoice(item)"
              >
                <v-icon left>mdi mdi-file-document-plus-outline</v-icon>
                Editar facturas asignadas
              </v-btn> -->
            </div>
            <div v-if="item.invoice">
              <!-- <div  style="display: flex; justify-content: flex-start; gap: 30px">
                <v-card class="mb-4 mx-4" style="width: 346px;" v-for="(item, idx) in item.invoice" :key="idx">
                  <v-card-title>
                    <h4>Invoice: {{ item.invoice.sInvoice }}</h4>
                    <v-spacer></v-spacer>
                    <v-chip
                      color="blue"
                      outlined
                    >{{ "Pagada" }}</v-chip>
                  </v-card-title>
                  <v-card-text>
                    <div class="mt-2"  style="display: flex; justify-content: space-around; flex-direction: column;">
                      <div style="display: flex; justify-content: space-between; align-items: center;  align-items: flex-start; flex-direction: column;">
                        <div class="my-2">
                          <div style="color: black; font-size: 20px;">
                            Monto
                          </div>
                          <div style="color: black; font-size: 22px; font-weight: bold;">
                            {{ "$ " + formatMoney(item.dAmount) + "MXN" }}
                          </div>
                        </div>
                        <div class="my-2">
                          <div style="color: black; font-size: 20px;">
                          Fecha de compra
                          </div>
                          <div style="color: black; font-size: 22px; font-weight: bold;">
                            {{ formatDate(item.invoice.dPurchaseDate) }}
                          </div>
                        </div>
                        <div class="my-2">
                          <div style="color: black; font-size: 20px; text-align: center;">
                            Exchange rate protected
                          </div>
                          <div style="color: black; font-size: 22px; font-weight: bold;">
                            {{ "$ " + formatMoney(item.invoice.dRateProtection) + " MXN" }}
                          </div>
                        </div>
                        <div class="my-2" style="display: flex; width: 100%; justify-content: space-around;">
                          <div>
                            <div class="mb-2" style="color: black; font-size: 20px;">
                              Profit (%)
                            </div>
                            <div :style="{ color: item.invoice.dProfitPercentage < 0 ? 'red' : 'green'}" style="color: black; font-size: 22px; font-weight: bold;">
                              {{ formatMoney(item.invoice.dProfitPercentage) + "%" }}
                            </div>
                          </div>
                          <div>
                            <div class="mb-2" style="color: black; font-size: 20px;">
                            Profit
                            </div>
                            <div :style="{ color: item.invoice.dProfitPercentage < 0 ? 'red' : 'green'}"style="color: black; font-size: 22px; font-weight: bold;">
                              {{ "$ " + formatMoney(item.invoice.dCurrencyGain) + " USD" }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </div> -->
              <v-data-table
                v-if="item.invoice.length > 0"
                item-key="sInvoiceTransactionId"
                :headers="headersInvoices"
                disable-sort
                :items="item.invoice"
              >
                <template v-slot:item.data-table-select="{ item, select }">
                  <v-checkbox
                    :input-value="isSelected(item)"
                    @click="toggleSelect(item, select)"
                    :disabled="item.sStatusId != '453f47d8-d5ad-4159-be49-b48b0f04caa5'"
                  ></v-checkbox>
                </template>
                <template v-slot:item.sName="{ item }">
                  <!-- <h4 style="font-family: 'Montserrat', sans-serif">{{ this.item }}</h4> -->
                </template>
                <template v-slot:item.dDueDate="{ item }">
                  <h4 style="font-family: 'Montserrat', sans-serif">
                    {{ formatDate(item.invoice.dDueDate) }}
                  </h4>
                </template>
                <template v-slot:item.dPurchaseDate="{ item }">
                  <h4 style="font-family: 'Montserrat', sans-serif">
                    {{ formatDate(item.invoice.dPurchaseDate) }}
                  </h4>
                </template>
                <template v-slot:item.sInvoice="{ item }">
                  <h4 style="font-family: 'Montserrat', sans-serif">{{ item.invoice.sInvoice }}</h4>
                </template>
                <template v-slot:item.sId="{ item }">
                  <h4 style="font-family: 'Montserrat', sans-serif">{{ item.invoice.sId }}</h4>
                </template>
                <template v-slot:item.dTotalAmount="{ item }">
                  <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                    $ {{ formatMoney(item.dAmount) }} MXN
                  </h4>
                </template>
                <template v-slot:item.dRateProtection="{ item }">
                  <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                    $ {{ formatMoney(item.invoice.dRateProtection) }} MXN
                  </h4>
                </template>
                <template v-slot:item.dProfitPercentage="{ item }">
                  <h4
                    :style="{ color: item.dProfitPercentage < 0 ? 'red' : 'green' }"
                    style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif"
                  >
                    {{ formatMoney(item.invoice.dProfitPercentage) + "%" }}
                  </h4>
                </template>
                <template v-slot:item.dCurrencyGain="{ item }">
                  <h4
                    :style="{ color: item.invoice.dCurrencyGain < 0 ? 'red' : 'green' }"
                    style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif"
                  >
                    $ {{ formatMoney(item.invoice.dCurrencyGain) }} USD
                  </h4>
                </template>
                <template v-slot:item.sStatusId="{ item }">
                  <v-chip
                    v-if="item.invoice.sStatusId == '453f47d8-d5ad-4159-be49-b48b0f04caa5'"
                    class="ma-2"
                    color="primary"
                    outlined
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "To pay" }}</h4>
                  </v-chip>
                  <v-chip
                    v-else-if="item.invoice.sStatusId == '904a91ab-bdfc-45dc-a72f-fc02c2a15005'"
                    class="ma-2"
                    outlined
                    color="green"
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "Assigned" }}</h4>
                  </v-chip>
                  <v-chip
                    v-else-if="item.invoice.sStatusId == 'f42d5b71-bcc8-4c2c-997a-40ad2da2bc31'"
                    class="ma-2"
                    outlined
                    color="#193D6E"
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "Paid" }}</h4>
                  </v-chip>
                  <v-chip
                    v-else-if="item.invoice.sStatusId == '63b83525-e0ff-4d52-821a-df20611cb4a3'"
                    class="ma-2"
                    outlined
                    color="red"
                  >
                    <h4 style="font-family: 'montserrat-medium';">{{ "Parcial" }}</h4>
                  </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div style="display: flex; align-items: center; justify-content: center">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="editInvoice(item)"
                          :disabled="loading"
                          v-bind="attrs"
                          v-on="on"
                          icon
                          color="black"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar factura</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="openDialogDeleteInvoice(item)"
                          :disabled="loading"
                          v-bind="attrs"
                          v-on="on"
                          icon
                          color="red"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Delete item</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
              <v-card v-else class="py-8" style="width: 100%; text-align: center;">
                <v-card-text>
                  <h4>No hay facturas asignadas</h4>
                </v-card-text>
              </v-card>
            </div>
          </v-card>
        </v-card-text>
      </div>
      <v-skeleton-loader
        v-else
        class="mx-3 my-3"
        height="100%"
        width="100%"
        type="image"
      ></v-skeleton-loader>
    </v-container>
    <v-dialog v-model="dialog" persistent>
      <v-card class="px-3 py-3">
        <div style="width: 100%; text-align: end;">
          <v-btn icon @click="dialog = false">
            <v-icon color="#2E404E">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card elevation="5" class="mb-6 mx-6 mt-2" style="display: flex; justify-content: space-between;">
          <div class="pa-5" style="display: flex; flex-direction: column;">
            <span class="mon-bold">Cantidad aplicada:</span>
            <span class="mon-bold">{{"$ " + formatMoney(item?.dTotalAmount) + " MXN"}}</span>
          </div>
          <div class="pa-5" style="display: flex; flex-direction: column;">
            <span class="mon-bold">Disponible:</span>
            <span class="mon-bold">{{"$ " + formatMoney(item?.dDescAmount - item?.dTotalAmount) + " MXN"}}</span>
          </div>
        </v-card>
        <v-card elevation="5" class="mb-6 mx-6">
          <v-card-text>
            <v-row class="pt-4" style="flex-direction: column; overflow-x: auto;">
              <h2 class="pa-4" style="color: black;">Facutras Aplicadas</h2>
              <div v-if="item">
                <div v-if="item.invoice.length > 0">
                  <v-data-table
                    item-key="sInvoiceId"
                    :headers="headersInvoices"
                    disable-sort
                    :items="item.invoice"
                  >
                    <template v-slot:item.data-table-select="{ item, select }">
                      <v-checkbox
                        :input-value="isSelected(item)"
                        @click="toggleSelect(item, select)"
                        :disabled="item.sStatusId != '453f47d8-d5ad-4159-be49-b48b0f04caa5'"
                      ></v-checkbox>
                    </template>
                    <template v-slot:item.sName="{ item }">
                      <!-- <h4 style="font-family: 'Montserrat', sans-serif">{{ this.item }}</h4> -->
                    </template>
                    <template v-slot:item.dDueDate="{ item }">
                      <h4 style="font-family: 'Montserrat', sans-serif">
                        {{ formatDate(item.invoice.dDueDate) }}
                      </h4>
                    </template>
                    <template v-slot:item.dPurchaseDate="{ item }">
                      <h4 style="font-family: 'Montserrat', sans-serif">
                        {{ formatDate(item.invoice.dPurchaseDate) }}
                      </h4>
                    </template>
                    <template v-slot:item.sInvoice="{ item }">
                      <h4 style="font-family: 'Montserrat', sans-serif">{{ item.invoice.sInvoice }}</h4>
                    </template>
                    <template v-slot:item.sId="{ item }">
                      <h4 style="font-family: 'Montserrat', sans-serif">{{ item.invoice.sId }}</h4>
                    </template>
                    <template v-slot:item.dTotalAmount="{ item }">
                      <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                        $ {{ formatMoney(item.dAmount) }} MXN
                      </h4>
                    </template>
                    <template v-slot:item.dRateProtection="{ item }">
                      <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                        $ {{ formatMoney(item.invoice.dRateProtection) }} MXN
                      </h4>
                    </template>
                    <template v-slot:item.dProfitPercentage="{ item }">
                      <h4
                        :style="{ color: item.dProfitPercentage < 0 ? 'red' : 'green' }"
                        style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif"
                      >
                        {{ formatMoney(item.invoice.dProfitPercentage) + "%" }}
                      </h4>
                    </template>
                    <template v-slot:item.dCurrencyGain="{ item }">
                      <h4
                        :style="{ color: item.invoice.dCurrencyGain < 0 ? 'red' : 'green' }"
                        style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif"
                      >
                        $ {{ formatMoney(item.invoice.dCurrencyGain) }} USD
                      </h4>
                    </template>
                    <template v-slot:item.sStatusId="{ item }">
                      <v-chip
                        v-if="item.invoice.sStatusId == '453f47d8-d5ad-4159-be49-b48b0f04caa5'"
                        class="ma-2"
                        color="primary"
                        outlined
                      >
                        <h4 style="font-family: 'montserrat-medium';">{{ "To pay" }}</h4>
                      </v-chip>
                      <v-chip
                        v-else-if="item.invoice.sStatusId == '904a91ab-bdfc-45dc-a72f-fc02c2a15005'"
                        class="ma-2"
                        outlined
                        color="green"
                      >
                        <h4 style="font-family: 'montserrat-medium';">{{ "Assigned" }}</h4>
                      </v-chip>
                      <v-chip
                        v-else-if="item.invoice.sStatusId == 'f42d5b71-bcc8-4c2c-997a-40ad2da2bc31'"
                        class="ma-2"
                        outlined
                        color="#193D6E"
                      >
                        <h4 style="font-family: 'montserrat-medium';">{{ "Paid" }}</h4>
                      </v-chip>
                      <v-chip
                        v-else-if="item.invoice.sStatusId == '63b83525-e0ff-4d52-821a-df20611cb4a3'"
                        class="ma-2"
                        outlined
                        color="red"
                      >
                        <h4 style="font-family: 'montserrat-medium';">{{ "Parcial" }}</h4>
                      </v-chip>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <div style="display: flex; align-items: center; justify-content: center">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="editInvoice(item)"
                              :disabled="
                                loading ||
                                item.sStatusId != '453f47d8-d5ad-4159-be49-b48b0f04caa5'
                              "
                              v-bind="attrs"
                              v-on="on"
                              icon
                              color="black"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Editar factura</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="openDialogDeleteInvoice(item)"
                              :disabled="
                                loading ||
                                item.sStatusId != '453f47d8-d5ad-4159-be49-b48b0f04caa5'
                              "
                              v-bind="attrs"
                              v-on="on"
                              icon
                              color="red"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Delete item</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-data-table>
                </div>
                <v-card v-else class="py-8" style="width: 100%; text-align: center;">
                  <v-card-text>
                    <h4>No hay facturas disponibles</h4>
                  </v-card-text>
                </v-card>
              </div>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card elevation="5" class="mb-6 mx-6">
          <v-card-text>
            <v-row class="pt-4" style="flex-direction: column; overflow-x: auto;">
              <h2 class="pa-4" style="color: black;">Facutras Disponibles</h2>
              <div v-if="avaibleInvoices">
                <div v-if="avaibleInvoices.length > 0">
                  <v-data-table
                    item-key="sInvoiceId"
                    :headers="headersInvoices"
                    disable-sort
                    :items="avaibleInvoices"
                  >
                    <template v-slot:item.sName="{ item }">
                      <h4 style="font-family: 'Montserrat', sans-serif">{{ item.sName }}</h4>
                    </template>
                    <template v-slot:item.dDueDate="{ item }">
                      <h4 style="font-family: 'Montserrat', sans-serif">
                        {{ formatDate(item.dDueDate) }}
                      </h4>
                    </template>
                    <template v-slot:item.dPurchaseDate="{ item }">
                      <h4 style="font-family: 'Montserrat', sans-serif">
                        {{ formatDate(item.dPurchaseDate) }}
                      </h4>
                    </template>
                    <template v-slot:item.sInvoice="{ item }">
                      <h4 style="font-family: 'Montserrat', sans-serif">{{ item.sInvoice }}</h4>
                    </template>
                    <template v-slot:item.sId="{ item }">
                      <h4 style="font-family: 'Montserrat', sans-serif">{{ item.sId }}</h4>
                    </template>
                    <template v-slot:item.dTotalAmount="{ item }">
                      <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                        $ {{ formatMoney(item.dTotalAmount) }} MXN
                      </h4>
                    </template>
                    <template v-slot:item.dRateProtection="{ item }">
                      <h4 style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif">
                        $ {{ formatMoney(item.dRateProtection) }} MXN
                      </h4>
                    </template>
                    <template v-slot:item.dProfitPercentage="{ item }">
                      <h4
                        :style="{ color: item.dProfitPercentage < 0 ? 'red' : 'green' }"
                        style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif"
                      >
                        {{ formatMoney(item.dProfitPercentage) + "%" }}
                      </h4>
                    </template>
                    <template v-slot:item.dCurrencyGain="{ item }">
                      <h4
                        :style="{ color: item.dCurrencyGain < 0 ? 'red' : 'green' }"
                        style="text-wrap: nowrap; font-family: 'Montserrat', sans-serif"
                      >
                        $ {{ formatMoney(item.dCurrencyGain) }} USD
                      </h4>
                    </template>
                    <template v-slot:item.sStatusId="{ item }">
                      <v-chip
                        v-if="item.sStatusId == '453f47d8-d5ad-4159-be49-b48b0f04caa5'"
                        class="ma-2"
                        color="primary"
                        outlined
                      >
                        <h4 style="font-family: 'montserrat-medium';">{{ "To pay" }}</h4>
                      </v-chip>
                      <v-chip
                        v-else-if="item.sStatusId == '904a91ab-bdfc-45dc-a72f-fc02c2a15005'"
                        class="ma-2"
                        outlined
                        color="green"
                      >
                        <h4 style="font-family: 'montserrat-medium';">{{ "Assigned" }}</h4>
                      </v-chip>
                      <v-chip
                        v-else-if="item.sStatusId == 'f42d5b71-bcc8-4c2c-997a-40ad2da2bc31'"
                        class="ma-2"
                        outlined
                        color="#193D6E"
                      >
                        <h4 style="font-family: 'montserrat-medium';">{{ "Paid" }}</h4>
                      </v-chip>
                      <v-chip
                        v-else-if="item.sStatusId == '63b83525-e0ff-4d52-821a-df20611cb4a3'"
                        class="ma-2"
                        outlined
                        color="red"
                      >
                        <h4 style="font-family: 'montserrat-medium';">{{ "Parcial" }}</h4>
                      </v-chip>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <div style="display: flex; align-items: center; justify-content: center">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="editInvoice(item)"
                              :disabled="
                                loading ||
                                item.sStatusId != '453f47d8-d5ad-4159-be49-b48b0f04caa5'
                              "
                              v-bind="attrs"
                              v-on="on"
                              icon
                              color="black"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Editar factura</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="openDialogDeleteInvoice(item)"
                              :disabled="
                                loading ||
                                item.sStatusId != '453f47d8-d5ad-4159-be49-b48b0f04caa5'
                              "
                              v-bind="attrs"
                              v-on="on"
                              icon
                              color="red"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Delete item</span>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-data-table>
                </div>
                <v-card v-else class="py-8" style="width: 100%; text-align: center;">
                  <v-card-text>
                    <h4>No hay facturas disponibles</h4>
                  </v-card-text>
                </v-card>
            </div>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAddInvoice" persitent width="500">
      <v-card
        class="elevation-16 mx-auto"
        width="500"
        v-if="item"
      >
        <v-card-title class="text-h5 mb-2">
          Invoice: {{ invoiceAdd.sInvoice }}
        </v-card-title>
        <div style="display: flex; justify-content: space-around; flex-direction: column;">
        <div style="display: flex; justify-content: space-between;">
          <h3 class="mon-bold pa-4">
            Monto de factura:
          </h3>
          <h3 class="mon-bold pa-4">
            {{ formatMoney(invoiceAdd.dTotalAmount) }}
          </h3>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <h3 class="mon-bold pa-4">
            Monto disponible:
          </h3>
          <h3 class="mon-bold pa-4">
            {{ formatMoney(item?.dDescAmount - item.dTotalAmount) }}
          </h3>
        </div>
          <v-card-subtitle class="mon-bold" style="font-size: 18px;">
            
          </v-card-subtitle>
          <v-text-field
            label="Cantidad a asignar"
            max-width="250px"
            style="max-width: 250px !important;"
            required
            ref="address"
            v-model="address"
            :rules="[
              () => (address <= (item?.dDescAmount - item.dTotalAmount)) || (address <= invoiceAdd.dTotalAmount)  || 'Excede el monto disponible'
            ]"
            outlined
          ></v-text-field>
        </div>
        <v-card-text class="mon-bold">
          
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-space-between">
          <v-btn text @click="dialogAddInvoice = false">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
          >
            Agregar factura
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

export default {
  name: "DashboardView",
  data() {
    return {
      nameXLSX: "HistorialPagos.xlsx",
      texts: "",
      loading: true,
      drawer: null,
      actualCurrency: "0",
      actualCurrencyMxn: "0",
      referenceCurrency: "0",
      isLoading: false,
      isRegisterEfex: true,
      exchangeRateData: [],
      selected: [],
      exchangeRateDataPaid: [],
      exchangeRateDataSeparate: [],
      balanceMxn: "0",
      balanceUsd: "0",
      balance: "0",
      items: [],
      address: null,
      loading: false,
      dialog: false,
      dialogAddInvoice: false,
      length: 2.5,
      rating: 2,
      itemss: [],
      tab: 0,
      contacts: [],
      itemsSelected: [],
      itemsSelectedForwards: [],
      isForwardRateCalculated: false,
      bSelectedAll: false,
      dialogAddFoundss: false,
      dialogSendPay: false,
      dialogAddFounds: false,
      dataAddFounds: {},
      dialogCreate: false,
      dialogPay: false,
      editableData: {},
      selectedCard: null,
      totalUsd: 0,
      totalProfit: 0,
      selectedMenuItem: "dashboard",
      headersInvoices: [
        this.selectLanguage === 'en' ? { text: "Invoice", value: "sInvoice", align: "center" } : { text: "Factura", value: "sInvoice", align: "center" },
        this.selectLanguage === 'en' ? { text: "Purchase Order", value: "sId", align: "center" } : { text: "Orden de compra", value: "sId", align: "center" },
        this.selectLanguage === 'en' ? { text: "Purchase date", value: "dPurchaseDate", align: "center" } : { text: "Fecha de compra", value: "dPurchaseDate", align: "center" },
        this.selectLanguage === 'en' ? { text: "Due date", value: "dDueDate", align: "center" } : { text: "Fecha de vencimiento", value: "dDueDate", align: "center" },
        this.selectLanguage === 'en' ? { text: "Status", value: "sStatusId", align: "center" } : { text: "Estado", value: "sStatusId", align: "center" },
        this.selectLanguage === 'en' ? { text: "Total amount MXN", value: "dTotalAmount", align: "center" } : { text: "Monto total MXN", value: "dTotalAmount", align: "center" },
        this.selectLanguage === 'en' ? { text: "Exchange rate protection MXN", value: "dRateProtection", align: "center", sortable: false } : { text: "Cobertura de tasa de cambio MXN", value: "dRateProtection", align: "center", sortable: false },   
        this.selectLanguage === 'en' ? { text: "Currency profit (%)", value: "dProfitPercentage", align: "center" } : { text: "Beneficio de moneda (%)", value: "dProfitPercentage", align: "center" },
        this.selectLanguage === 'en' ? { text: "Currency gain", value: "dCurrencyGain", align: "center" } : { text: "Beneficio de moneda", value: "dCurrencyGain", align: "center" },
        // this.selectLanguage === 'en' ? { text: "Actions", value: "actions", align: "center" } : { text: "Acciones", value: "actions", align: "center" }
      ],
      contactData: {
        sName: "",
        sEmail: "",
        sBank_name: "",
        sAccount_number: "",
        sEntity_business: "COMPANY"
      },
      isForwardsActive: false,
      showCreateProvider: false,
      isResponsive: false,
      screenWidth: 0,
      bLoading: false,
      isDeferredPayment: false,
      stepper: false,
      e1: 1,
      timerCount: 30,
      headersForex: [
        {
          text: "Id",
          value: "iTrackingId",
          align: "center",
          sortable: false
        },
        { text: "Fecha de pago", value: "created_at", align: "center" },
        { text: "Destinatario", value: "sName", align: "center" },
        {
          text: "Invoice",
          value: "invoice",
          align: "center",
          sortable: false
        },
        { text: "Type Transaction", value: "type", align: "center" },
        { text: "Total amount MXN", value: "dDesAmount", align: "center" },
        { text: "Total amount USD", value: "dAmount", align: "center" },
        { text: "Exchange rate", value: "dExchangeRate", align: "center" },
        {
          text: "Currency profit (%)",
          value: "percentProfit",
          align: "center"
        },
        { text: "Currency gain USD", value: "dollarProfit", align: "center" },
        { text: "Actions", value: "actions", align: "center", sortable: false }
      ],
      invoiceAdd: {},
      timerId: null,
      dataEfex: {},
      exchangeRateAdjustments: [],
      exchangeRatesStateForwards: [],
      isPayMxn: false,
      avaibleInvoices: [],
      bSelectedAllSeparate: false,
      dialogEditProfileActive: false,
      isForwards: false,
      isForwardsPayment: false,
      userName: "",
      dTotalAmount: "",
      dDescAmount: "",
      modalCurrency: 0,
      miniVariant: true,
      item: null,
      expandOnHover: false,
      registerFields: [
        { model: "sBankName", type: "text", label: "sBankName" },
        { model: "sAccountNumber", type: "text", label: "sAccountNumber" },
        { model: "sRoutingNumber", type: "text", label: "sRoutingNumber" }
      ],
      transactions: [],
      invoices: []
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    tabStyle(tabIndex) {
      return {
        color: this.tab === tabIndex ? "#f0be43" : "#506172",
        fontSize: "16px",
        fontWeight: "600",
        width: "200px",
        lineHeight: "24px",
        fontFamily: "montserrat-bold"
      };
    },
    handleResize: function () {
      if (window.innerWidth >= 960) {
        this.screenWidth = 30;
      } else {
        this.screenWidth = 100;
      }

      this.isResponsive = window.innerWidth < 960;
    },
    getPaymentsHistory() {
      this.isLoading = true;
      DB.get(`${URI}/api/v1/${this.selectLanguage}/payments/${this.$route.params.idPayment}`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
        .then((response) => {
          this.item = response.data.payment;
          this.item.invoice = this.item.invoice_payments_relationship
          this.item.dExchangeRateReal = this.item.transaction[0].transaction.dDesAmount / this.item.transaction[0].transaction.dAmount;
          if (this.item.totalActualCost) {
            this.item.dAmount = parseFloat(this.item.totalActualCost)
          } else {
            this.item.dAmount = this.item.dDescAmount / this.item.dExchangeRateReal;
          }
          this.item.dTotalAmount = 0;
          this.item.invoice_payments_relationship.map((invoice) => {
            this.item.dTotalAmount += parseFloat(invoice.dAmount);
              return invoice;
          })

          this.dTotalAmount = this.item.dTotalAmount;
          this.dDescAmount = this.item.dDescAmount;
          this.totalProfit = response.data.totalProfit;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error)
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        })
    },
    updateInvoice(item) {
      this.dialog = true;
      this.isLoadingInvoices = true;
      this.avaibleInvoices = [];

      const payload = {
        sPaymentRecipientId: item.sPaymentRecipientId,
        dExchangeRate: item.dRate,
      };

      DB.post(`${URI}/api/v1/${this.selectLanguage}/invoices/supplier`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : "",
        },
      })
        .then((response) => {
          this.avaibleInvoices = response.data.invoices;
          this.isLoadingInvoices = false;
        })
        .catch((error) => {
          this.isLoadingInvoices = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    addInvoice(item) {
      console.log(item)
      this.invoiceAdd = item;
      this.dialogAddInvoice = true;
    },
    cancel() {
      this.dialog = false;
      this.dialogAddInvoice = false;
    },
    downloadReceipt(item) {
      this.loading = true;
      const payload = {
        sPaymentId: this.$route.params.idPayment
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/payments/paymentReceipt`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          if (response.data && response.data.payment) {
            let base64 = response.data.paymentReceipt.data;

            const base64Pattern =
              /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+);base64,/;
            if (base64Pattern.test(base64)) {
              base64 = base64.split(",")[1];
            }

            try {
              const binaryString = window.atob(base64);
              const bytes = new Uint8Array(binaryString.length);
              for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
              }
              const blob = new Blob([bytes], { type: "application/pdf" });

              this.loading = false;
              const url = URL.createObjectURL(blob);
              window.open(url, "_blank");
            } catch (e) {
              this.loading = false;
            }
          } else {
            this.loading = false;
          }
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    getInvoices() {
      DB.get(
        `${URI}/api/v1/${this.selectLanguage}/invoices/?exchangeRateToday=${this.actualCurrency}`,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      ).then((response) => {
        this.invoices = response.data.invoices;
      });
    },
    getTransactions() {
      DB.get(`${URI}/api/v1/${this.selectLanguage}/transactions/`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      }).then((response) => {
        this.transactions = response.data.transactions;
      });
    },
    formatMoney: function (value) {
      let multiplied = value * 100;
      let rounded = Math.round(multiplied);
      let formattedNumber = rounded / 100;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(formattedNumber);
    },
    getExchangeRate: function () {
      this.items = [];

      DB.get(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/?exchangeRateToday=${this.actualCurrency}`,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          this.isForwardsActive = response.data.isForwardsActive;
          this.userName = response.data.user;
          this.isRegisterEfex = response.data.registerInEfex;
          this.exchangeRateDataPaid =
            response.data.exchangeRate.exchangeRatesStatePaid;
          this.exchangeRateData =
            response.data.exchangeRate.exchangeRatesStateToPay;
          this.exchangeRateDataSeparate =
            response.data.exchangeRate.exchangeRatesStateSeparated;
          this.exchangeRatesStateForwards =
            response.data.exchangeRate.exchangeRatesStateForwards;
          this.balanceMxn = response.data.balance.balanceMxn;
          this.balanceUsd = response.data.balance.balanceUsd;
          this.exchangeRateAdjustments = response.data.exchangeRateAdjustments;
          this.balance =
            parseFloat(this.balanceMxn) / parseFloat(this.actualCurrency) +
            parseFloat(this.balanceUsd);
          this.balance = this.balance.toString();

          // this.totalUsd = 0;

          // this.itemsSelected.forEach((item) => {
          //   item.dTotalUsdToday = parseFloat(item.dTotalUsdToday);
          //   this.totalUsd += item.dTotalUsdToday;
          // });

          this.mixSuccess(response.data.message);
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        })
        .finally(() => {
          this.getContacts();
        });
    },
    getContacts: function () {
      DB.get(`${URI}/api/v1/${this.selectLanguage}/contacts-wallet/`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
        .then((response) => {
          this.contacts = response.data.contacts;
          this.contacts.push({
            id: 0,
            name: "Crear nuevo contacto"
          });
        })
        .catch((error) => {
          // Handle error if needed
        });
    },
    openModalAddFounds() {},
    openModalSendPay() {
      this.dialogSendPay = true;
    },
    openModalAddFoundss() {
      this.dialogAddFoundss = true;

      const payload = {
        amount: 100
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/addFounds`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          this.dataAddFounds = response.data.account;
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    closeModalAddFounds() {
      this.dialogAddFounds = false;
    },
    toggleAll: function (checked) {
      this.exchangeRateData.forEach((item) => {
        if (
          item.statusName !== "WAITING_FOR_DEPOSIT" ||
          item.statusName !== "PROCESSING"
        ) {
          item.bSelected = checked;
        }
      });
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM D, YYYY");
      return formattedDate;
    },
    // formatMoney: function (money) {
    //   return FORMAT_MONEY(money);
    // },
    resetForm() {
      this.editableData = {
        dPurchaseDate: "",
        sProvider: "",
        sInvoiceNumber: "",
        dDescAmount: "",
        iCreditPeriod: "",
        dInvoiceExchangeRateProtection: ""
      };
    },
    openModalCreate() {
      this.dialogCreate = true;
      this.resetForm();
    },
    validateForm: function () {
      return true;
    },
    saveChanges: function () {
      this.bLoading = true;
      let newdPurchaseDate = this.formatDateToSend(
        this.editableData.dPurchaseDate
      );

      const payload = {
        dPurchaseDate: newdPurchaseDate.toString(),
        sProvider: this.editableData.sProvider,
        sInvoiceNumber: this.editableData.sInvoiceNumber,
        dDescAmount: parseFloat(this.editableData.dDescAmount),
        iCreditPeriod: parseInt(this.editableData.iCreditPeriod),
        createContact: this.showCreateProvider,
        contactData: this.contactData,
        dInvoiceExchangeRateProtection:
          this.editableData.dInvoiceExchangeRateProtection
      };
      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.sToken}`
        }
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/`,
        payload,
        config
      )
        .then((response) => {
          this.bLoading = false;
          this.dialogCreate = false;
          this.mixSuccess(response.data.message);
          this.getExchangeRate();
          this.closeDialog();
        })
        .catch((error) => {
          this.bLoading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    formatDateToSend: function (date) {
      let newDate = new Date(date);
      let day = newDate.getDate() + 1;
      let month = newDate.getMonth() + 1;
      let year = newDate.getFullYear();
      return `${year}-${month}-${day}`;
    },
    changebSelectedAll: function () {
      this.bSelectedAll = !this.bSelectedAll;
    },
    closeModalCreate() {
      this.dialogCreate = false;
      this.showCreateProvider = false;
      this.contactData = {
        sName: "",
        sEmail: "",
        sBank_name: "",
        sAccount_number: "",
        sEntity_business: "COMPANY"
      };
    },
    sendToPayNow: function () {
      this.isDeferredPayment = false;
      this.sendToPay();
    },
    sendToPay: function () {
      this.itemsSelected = this.exchangeRateData.filter(
        (item) => item.bSelected
      );
      if (this.itemsSelected.length > 0) {
        this.stepper = true;
        this.itemsSelected.forEach((item) => {
          item.dTotalUsdToday = parseFloat(item.dTotalUsdToday);
          this.totalUsd += item.dTotalUsdToday;
        });
      } else {
        this.mixError("No hay elementos seleccionados", 400);
      }
    },
    actualizarE1(nuevoValor) {
      this.e1 = nuevoValor;
    },
    closeModalPay() {
      this.dialogPay = false;
      this.totalUsd = 0;
      this.e1 = 1;
    },
    sendToPayNowMxn: function () {
      this.isDeferredPayment = false;
      this.isPayMxn = true;
      this.itemsSelected = this.exchangeRateDataSeparate.filter(
        (item) => item.bSelected
      );
      this.itemsSelected.forEach((item) => {
        item.dTotalUsdToday = parseFloat(item.dTotalUsdToday);
        this.totalUsd += item.dTotalUsdToday;
      });

      if (this.itemsSelected.length > 0) {
        this.dialogPay = true;
      } else {
        this.mixError("No hay elementos seleccionados", 400);
      }
    },
    sendToPayNowForwards: function () {
      console.log("sendToPayNowForwards");
      this.isPayMxn = true;
      this.itemsSelected = this.exchangeRatesStateForwards.filter(
        (item) => item.bSelected
      );
      this.itemsSelected.forEach((item) => {
        item.dTotalUsdToday = parseFloat(item.dTotalUsdToday);
        this.totalUsd += item.dTotalUsdToday;
      });

      if (this.itemsSelected.length > 0) {
        this.sendPayEfex();
      } else {
        this.mixError("No hay elementos seleccionados", 400);
      }
    },
    closeModalStepper() {
      this.stepper = false;
      this.totalUsd = 0;
      this.e1 = 1;
      this.isForwards = false;
      this.isForwardsPayment = false;
      //this.getActualCurrency();
    },
    changeDeferredPayment() {
      this.isDeferredPayment = !this.isDeferredPayment;
    },
    changePayMxn() {
      this.isPayMxn = !this.isPayMxn;
    },
    sendPayEfex: function () {
      this.bLoading = true;

      if (this.isPayMxn) {
        this.totalUsd = this.totalUsd * this.actualCurrency;
      }

      const payload = {
        pays: this.itemsSelected,
        referenceCurrency: this.referenceCurrency,
        actualCurrency: this.actualCurrency,
        isDeferredPayment: this.isDeferredPayment,
        isPayMxn: this.isPayMxn,
        totalUsd: this.totalUsd
      };

      console.log("payload", payload);

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/sendPayment/`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          console.log("response", response);
          if (!response.data.status) {
            this.mixError(response.data.message, 400);
          } else {
            this.mixSuccess(response.data.message);
          }
          this.bLoading = false;
          this.dialogPay = false;
          this.defferedPayment = false;
          this.getExchangeRate();
          this.totalUsd = 0;
          this.isPayMxn = false;
        })
        .catch((error) => {
          this.bLoading = false;
          this.mixError(error.data.message, error.response.status);
        });
    },
    openReceipt(item) {
      this.loading = true;
      const payload = {
        sPaymentId: item.sPaymentId
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/payments/paymentReceipt`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          if (response.data && response.data.payment) {
            let base64 = response.data.paymentReceipt.data;

            const base64Pattern =
              /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+);base64,/;
            if (base64Pattern.test(base64)) {
              base64 = base64.split(",")[1];
            }

            try {
              const binaryString = window.atob(base64);
              const bytes = new Uint8Array(binaryString.length);
              for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
              }
              const blob = new Blob([bytes], { type: "application/pdf" });

              this.loading = false;
              const url = URL.createObjectURL(blob);
              window.open(url, "_blank");
            } catch (e) {
              this.loading = false;
            }
          } else {
            this.loading = false;
          }
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    sendSeparateEfex: function () {
      this.bLoading = true;
      const payload = {
        exchangeRateId: this.itemsSelected,
        rateUuid: this.referenceCurrency,
        rateInt: this.actualCurrency
      };

      console.log("payload", payload);

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/separateExchangeRate/`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          if (!response.data.status) {
            this.mixError(response.data.message);
          } else {
            this.mixSuccess(response.data.message);
          }
          this.bLoading = false;
          this.dialogSeparate = false;
          this.getExchangeRate();
        })
        .catch((error) => {
          this.bLoading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    toggleAllSeparated: function (checked) {
      this.exchangeRateDataSeparate.forEach((item) => {
        item.bSelected = checked;
      });
    },
    toggleAllForwards: function (checked) {
      this.exchangeRatesStateForwards.forEach((item) => {
        console.log("item", item);
        this.$set(item, "bSelected", checked);
      });
    },
    createSubAccount(data) {
      const payload = {
        sBank_name: data.sBankName,
        sAccount_number: data.sAccountNumber,
        sRouting_number: data.sRoutingNumber,
        clabe: data.clabe,
        sBank_mxn_account: data.sBankMxnAccount
      };

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.sToken}`
        }
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/sub-account/`,
        payload,
        config
      )
        .then((response) => {
          this.mixSuccess(response.data.message);
          this.getExchangeRate();
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    openModal(item) {
      this.totalUsd = 0;
      this.selectedItem = item;
      this.editableData = { ...this.selectedItem };
      this.dialogEditProfileActive = true;
    },
    closeDialog() {
      this.dialogEditProfileActive = false;
    },
    backStep() {
      this.e1 = 1;
    },
    updateExchangeRate: function () {
      this.bLoading = true;
      let newdPurchaseDate = this.formatDateToSend(
        this.editableData.dPurchaseDate
      );
      const payload = {
        sExchangeRateId: this.selectedItem.sExchangeRateId,
        dPurchaseDate: newdPurchaseDate.toString(),
        sProvider: this.editableData.sProvider,
        sInvoiceNumber: this.editableData.sInvoiceNumber,
        dDescAmount: parseFloat(this.editableData.dDescAmount),
        iCreditPeriod: parseInt(this.editableData.iCreditPeriod),
        dInvoiceExchangeRateProtection:
          this.editableData.dInvoiceExchangeRateProtection,
        dAmountAdjustment: parseFloat(this.editableData.dAmountAdjustment),
        sCurrencyAdjustment: "MXN"
      };

      const config = {
        headers: {
          Authorization: `Bearer ${this.$store.state.sToken}`
        }
      };

      DB.put(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/${this.selectedItem.sExchangeRateId}`,
        payload,
        config
      )
        .then((response) => {
          this.bLoading = false;
          this.dialogEditProfileActive = false;
          this.mixSuccess(response.data.message);
          this.getExchangeRate();
          this.closeDialog();
        })
        .catch((error) => {
          this.bLoading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    changeForwards: function (value) {
      this.isForwards = value;
    },
    getForwards: function () {
      this.bLoading = true;
      const payload = {
        pays: this.itemsSelected,
        referenceCurrency: this.referenceCurrency,
        reverse: true
      };
      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/getRateForwards/`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          if (!response.data.status) {
            this.mixError(response.data.message, 400);
            this.bLoading = false;
            this.isForwardsPayment = false;
          } else {
            this.mixSuccess(response.data.message);
            this.bLoading = false;
            this.isForwardsPayment = true;
            this.isForwardRateCalculated =
              response.data.isForwardRateCalculated;
            this.itemsSelected = response.data.responsePaysEfex;
          }
          this.getExchangeRate();
        })
        .catch((error) => {
          this.bLoading = false;
          this.isForwardsPayment = false;
          this.mixError(error.data.message, 400);
        });
    },
    sendForwardPayment: function () {
      const payload = {
        pays: this.itemsSelected
      };
      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/exchange-rate/sendPayForward/`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }
      )
        .then((response) => {
          if (!response.data.status) {
            this.mixError(response.data.message, 400);
          } else {
            this.mixSuccess(response.data.message);
          }
          this.bLoading = false;
          this.stepper = false;
          this.defferedPayment = false;
          this.getExchangeRate();
          this.totalUsd = 0;
          this.isForwardsPayment = false;
          this.isPayMxn = false;
        })
        .catch((error) => {
          this.bLoading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    changeModalCurrency: function (value) {
      this.modalCurrency = value;
    },
    updateTotalUsd: function (value) {
      this.totalUsd = value;
    },
    dataXLSX() {
      try {
        let data = this.items.map((item) => {
          return {
            Id: item.iTrackingId ? item.iTrackingId : "",
            "Fecha de pago": item.created_at ? this.formatDate(item.created_at) : "",
            "Destinatario": item.payment_recipient.sName ? item.payment_recipient.sName : "N/A",
            Invoice: item.invoice ? item.invoice : "",
            "Type Transaction": item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3' ? 'Forward' : (item.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a' ? 'Forex' : (item.sTransactionType == 'ea9d350f-f00b-4763-90db-72e7af54dc73' ? 'Pay Now' : "N/A")),
            "Total amount (MXN)": item.dDesAmount ? parseFloat(item.dDesAmount) : "",
            "Total amount (USD)": item.dAmount ? parseFloat(item.dAmount) : "",
            "Exchange rate": item.dExchangeRate ? item.dExchangeRate : "",
            "Currency profit (%)": item.percentProfit ? parseFloat(item.percentProfit) : "",
            "Currency gain (USD)": item.dollarProfit ? parseFloat(item.dollarProfit) : "",
          };
        });
        const worksheet = XLSX.utils.json_to_sheet(data);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Hoja1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        saveAs(blob, this.nameXLSX);
        this.success = true;
        this.msgSuccess = "Descargando documento";
      } catch (error) {
        this.error = true;
        this.codeError = "CSV_NO_DATA";
      }
    },
  },
  beforeMount() {
    this.texts = FILE.takeRate[this.selectLanguage];
    this.getPaymentsHistory();
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
    formattedTime() {
      const minutes = Math.floor(this.timerCount / 60);
      const seconds = this.timerCount % 60;
      return `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    }
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.takeRate[this.selectLanguage];
      }
    },
    "editableData.sProvider": function (newValue) {
      this.showCreateProvider = newValue === 0;
    }
  }
};
</script>

<style scoped>
.bg-container {
  width: 100%;
  background: #fff;
  opacity: 1;
  height: 100%;
}
.full-height {
  height: 100vh;
  width: 100%;
  overflow-y: auto;
}
.active {
  background-color: #f0f0f0;
}
/* .active-section .v-list-item__icon {
  color: yellow !important;
  background-color: yellow !important;
}

.active-section .v-list-item__title {
  background-color: yellow !important;
} */

.active-item {
  background-color: #f5f7f9 !important;
}
.button-add {
  background: transparent linear-gradient(258deg, #ffc556 0%, #fffc81 100%) 0%
    0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0px;
  color: #283c4d;
  text-transform: initial;
}
.v-tabs-slider {
  background: #f0be43 !important;
  height: 3px;
  color: #f0be43 !important;
  border-radius: 100px;
}

.card-main {
  width: 40vh;
  height: 16vh;
  position: relative;
  background: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  overflow: hidden;
}

.card-content {
  position: absolute;
  top: 19px;
  left: 16px;
}

.circle-content {
  text-align: center;
  color: white;
  margin: auto;
}

.btn-custom {
  color: #f0be43;
}

.card-title {
  color: #302e2e;
  font-size: 16px;
  font-family: montserrat-bold;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 8px;
}

.card-info,
.balance-title {
  color: #777777;
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
}

.card-mxn {
  width: 200px;
  color: #f0be43;
  font-size: 24px;
  font-family: Mons;
  font-weight: 700;
  line-height: 36px;
  font-style: normal;
  word-wrap: break-word;
}

.container-width,
.header-container {
  max-width: 1280px;
  margin: auto;
}

.title-medium {
  font-family: "montserrat-semibold";
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.headline-medium {
  font-family: "montserrat-semibold";
  font-size: 28px;
  font-weight: 600;
  line-height: 36px;
  text-align: left;
}

.body-large {
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}

.blocked-amount {
  font-family: "montserrat-regular";
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.blocked-amount-2 {
  color: #302e2e;
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
}

.circle-sheet {
  width: 200px;
  height: 200px;
  padding-left: 17px;
  padding-right: 62px;
  overflow: hidden;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  position: absolute;
  right: -60px;
  top: -20px;
}

.usd-balance {
  color: #666565;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.content-balance {
  color: #302e2e;
  font-family: "montserrat-medium", sans-serif;
  font-size: 22px;
  font-weight: 600;
  line-height: 28px;
  text-align: left;
  padding-top: 10px;
}

.h5 {
  font-family: "montserrat-bold";
  font-size: 24px;
  line-height: 36px;
  text-align: left;
}

.buttonAddFounds {
  text-align: center;
  color: #f0be43;
  font-size: 16px;
  font-family: "montserrat-semibold";
  font-weight: 600;
  line-height: 24px;
  text-transform: capitalize;
  word-wrap: break-word;
}

.modalTextAddFounds {
  color: #302e2e;
  font-family: "Montserrat-Regular", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.table th {
  background-color: #f2f2f4;
  /* border: 1px solid #ccc; */
}

@media (max-width: 1150px) {
  .card-title {
    font-size: 14px;
  }

  .card-mxn {
    font-size: 20px;
  }

  .usd-balance {
    font-size: 12px;
  }

  .content-balance {
    font-size: 18px;
  }

  .blocked-amount {
    font-size: 12px;
  }

  .blocked-amount-2 {
    font-size: 14px;
  }

  .buttonAddFounds {
    font-size: 14px;
  }

  .circle-sheet {
    display: none;
  }
}

@media (max-width: 1250px) {
  .circle-sheet {
    width: 155px;
    height: 170px;
    padding-left: 17px;
    padding-right: 40px;
    right: -50px;
    top: -5px;
  }
}
</style>
